import { Component, OnInit } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { Router } from '@angular/router';
import { UsersService } from 'src/app/services/users/users.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { User } from 'src/app/classes/user';
import { RegisterPage } from '../register/register.page';
import { FcmService } from 'src/app/services/fcm/fcm.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {

  login={email:"", password:""};
  mensajeError=<any>{};
  constructor(
    private modalController: ModalController,
    private userService:UsersService,
    private utility:UtilsService,
    private router:Router,
    private global:GlobalService,
    private platform:Platform,
    private fcmService:FcmService
  ) { }

  ngOnInit() {
  }


  async loginUser() {
    this.mensajeError={};
      if(this.login.email==""){
        this.mensajeError.email="Debe introducir un email";
        return false;
      }
      if(this.login.password==""){
        this.mensajeError.password="Debe introducir una contraseña";
        return false;
      }
      let loading=this.utility.showLoaderControllable("Iniciando sesión ...");
      (await loading).present();
      this.userService.loginUser(this.login.email.trim(), this.login.password.trim()).then(resu=>{
        console.log(resu);
        
        loading.then(res=>{
          res.dismiss();
          this.userService.getCurrentUser(resu.user.uid).subscribe((user:User)=>{
            this.global.uid=user.uid;
            this.global.role=user.datos.role;
            if(this.platform.is("cordova")){
              this.fcmService.getToken();
            }
          });
          this.back();
        });     
      }, err=>{
        console.log(err);
        loading.then(res=>{res.dismiss();});
        let mensaje=this.utility.traductor(err.message);
        this.mensajeError=mensaje;
      }).catch(err=>{
        console.log(err);
        loading.then(res=>{res.dismiss();});
        let mensaje=this.utility.traductor(err.message);
        this.mensajeError=mensaje;
      });
  }

  forgot(){
    this.utility.presentAlertInput("Recupero de contraseña", "Ingresá tu email", "email", "Email", "").then(data=>{
      if(data.data.values.param){
        this.userService.forgotPassword(data.data.values.param).then(res=>{
          console.log(res);
          this.utility.presentSimpleAlert("Hemos enviado un email a tu casilla", "para recuperar tu contraseña segui los pasos alli indicados", "", "Entiendo");
        }).catch(err=>{
          var mensaje= this.utility.traductor(err.message);
          this.utility.presentSimpleAlert(mensaje, "", "", "Entiendo");
          console.log(err);
        });        
      }
    });
  }
  goRegister(){
      this.utility.edcModal(RegisterPage, "");
      this.back();
  }
  back(){
    this.modalController.dismiss();  
  }
}
